import classnames from "classnames"
import React from "react"
import LazyQuillEditor from "../../quill/LazyQuillEditor"
import FieldWrapper from "../form-utils/FieldWrapper"

const RichTextInput = React.forwardRef(function RichTextInput(
  { readOnly, ...props },
  ref
) {
  return (
    <FieldWrapper
      {...props}
      className={classnames("RichTextInput", props.className)}
    >
      {({ value, ...passProps }) => (
        <LazyQuillEditor
          {...passProps}
          html={value}
          ref={ref}
          bounds=".RichTextInput"
          readOnly={readOnly}
        />
      )}
    </FieldWrapper>
  )
})

RichTextInput.displayName = "RichTextInput"

export default RichTextInput
